export const getLocalizedText = (spanish, english) =>
  (localStorage.getItem("language") || "es") === "es" ? spanish : english;
